<template>
  <div>
    <div class="box" v-if="topItems.length > 1">
      <div ref="tabs" class="tab-row">
        <div
          v-for="(tab, index) in topItems"
          :key="tab.key"
          @click="changeTag(index)"
          :class="['box-wrapper', index === currentIndex && 'current-tab']"
        >
          <p
            :class="[index === currentIndex ? 'current-text' : 'normal-text']"
            >{{ tab.value }}</p
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import eventBus from '@fund/basic-lib/dist/lib/eventBus';

export default {
  props: {
    mergeData: Object,
    fundCode: String,
  },

  data() {
    return {
      currentIndex: 0,
      eleName: 'ProductInfo',
    };
  },

  computed: {
    // tab配置
    topItems() {
      const temp = [
        { value: '产品信息', eleName: 'ProductInfo', key: 'productInfo' },
      ];
      if (!isEmpty(this.mergeData?.onePageRead)) {
        temp.push({
          value: '产品解读',
          eleName: 'OnePage',
          key: 'productRead',
        });
      } else if (!isEmpty(this.mergeData?.readInfo)) {
        temp.push({
          value: '产品解读',
          eleName: 'MarketOnePage',
          key: 'productRead',
        });
      }
      const list = this.mergeData?.sameTypeProduct || [];
      // 排除基金本身
      const sameTypeProduct = list.filter(
        (item) => item.fundCode !== this.fundCode,
      );
      if (!isEmpty(sameTypeProduct)) {
        temp.push({
          value: '同系列产品',
          eleName: 'SameProduct',
          key: 'sameTypeProduct',
        });
      }
      return temp;
    },
  },

  created() {
    eventBus.$on('open-remind-to-switch-tab', () => {
      const index = this.topItems.findIndex((item) => item.key === 'sameTypeProduct');
      if (index >= 0) {
        this.changeTag(index);
      }
    });
  },

  methods: {
    changeTag(index) {
      this.currentIndex = index;
      const { key = '', eleName = '' } = this.topItems[index];
      this.eleName = eleName;
      const reportMap = {
        productInfo: 'wxgdpzy.ftab.cpxx.click',
        sameTypeProduct: 'wxgdpzy.ftab.txlcp.click',
        productRead: 'wxgdpzy.ftab.cpjd.click',
      };
      if (reportMap?.[key]) {
        this.$wxSendTrack(reportMap[key], 'Click', { infoCode: this.fundCode, infoCodeType: 5 });
      }
      eventBus.$emit('high-end-product-change-tab', { eleName: this.eleName });
    },
  },
};
</script>

<style scoped>
.box {
  background: #f5f5f5;
  padding-top: 24px;
  height: 70px;
}

.tab-row {
  display: flex;
  flex-direction: row;
  justify-self: center;
  justify-content: center;
  background: #ededed;
  border-radius: 8px;
  width: auto;
}

.current-text {
  font-family: PingFangSC-Medium;
  font-size: 30px;
  color: #000000;
  text-align: center;
  line-height: 58px;
  padding: 0 24px;
}

.normal-text {
  font-family: PingFangSC-Regular;
  font-size: 30px;
  color: #666666;
  text-align: center;
  line-height: 58px;
  padding: 0 24px;
  /* border: 1px solid red; */
}

.box-wrapper {
  /* flex: 1; */
  height: 58px;
  margin: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.current-tab {
  /* flex: 1; */
  background: #ffffff;
  border-radius: 8px;
}
</style>
